define('adminNotificationsToolsView',[
  'app',
  'module',
  'underscore', 
  'tableFieldView',
  'ordersDetailView',
  'notificationCenter',
  'template!adminNotificationsToolsView'
], function (
  App,
  Module,  
  _,
  FieldView,
  DetailView,
  NotificationCenter,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-notifications-tools-view table-field-view',

    modelEvents: {
      'change:read': 'renderSeen'
    },

    ui: {
      seen: '.seen-button',
      seenAll: '.seen-all-button',
      target: '.target-button'
    },

    events: {
      'click @ui.target': 'onOpenTarget',
      'click @ui.seen': 'onSeen',
      'click @ui.seenAll': 'onSeenAll'
    },

    onRender: function () {
      this.renderSeen();
      if (!this.model.get('notificationKey')) {
        this.ui.seenAll.hide();
      }
    },

    renderSeen: function () {
      if(this.model.get('read') === true)
        this.ui.seen.addClass('activated');
      else
        this.ui.seen.removeClass('activated');
    },

    onSeen: function (e) {
      e.stopPropagation();
      e.preventDefault();
      this.model.read().done(_.bind(function () {
        if(this.field.onSeen)
          this.field.onSeen();
      }, this));
    },

    onSeenAll: function (e) {
      e.stopPropagation();
      e.preventDefault();
      var notificationKey = this.model.get('notificationKey');
      if (notificationKey) {
        App.request('notifications:read-all-by-key', notificationKey).done(_.bind(function () {
          this.model.set('read', true);
          if(this.field.onSeen)
            this.field.onSeen();
        }, this));
      }
    },

    onOpenTarget: function (e) {
      e.stopPropagation();
      switch(this.model.get('content').type) {
        case 'ORDER_STATUS_CHANGED':
        case 'ORDER_NEW_COMMENT':
        case 'ORDER_NEW_PAYMENT':
        case 'ORDER_COMMENT_TAGGED':
        case 'ORDER_VALIDATED':
        case 'ORDER_INVALIDATED':
        case 'ORDER_ASSIGNED':
        case 'ORDER_COMMENT_MODIFIED_TAGGED':
        case 'ORDER_SUPPLIER_TRACKING_ADDED':
        case 'ORDER_TRACKING_ALERT':
          DetailView.prototype.open(this.model.get('content').data.poi);
          break;
        case 'ORDER_SUPPLIER_PORTAL_STATUS_CHANGED':
        case 'ORDER_SUPPLIER_PORTAL_MESSAGE':
          // Raised by the supplier, so opened on the supplier's tab: that is
          // where their status and the conversation with them are.
          DetailView.prototype.open(this.model.get('content').data.poi, 'order_supplier');
          break;
        case 'TASK_NEW':
        case 'TASK_NEW_COMMENT':
        case 'TASK_COMMENT_DELETED':
        case 'TASK_DONE':
          App.navigate('admin/tasks/' + this.model.get('content').entitySecId, {trigger: true});
          break;
        case 'CUSTOMER_COMMENT_MODIFIED_TAGGED':
        case 'CUSTOMER_COMMENT_TAGGED':
          App.navigate('customers/' + this.model.get('content').entitySecId, {trigger: true});
          break;
        case 'CALENDAR_VACATION_APPROVAL_REQUEST':
        case 'CALENDAR_VACATION_APPROVED':
        case 'CALENDAR_VACATION_REJECTED':
        case 'CALENDAR_REMINDER':
        case 'CALENDAR_GROUP_EVENT':
          App.navigate('calendar', {trigger: true});
          break;
        case 'EMAIL_REPLY_RECEIVED':
        case 'CUSTOMER_EMAIL_RECEIVED':
          // The reply opened over its worklist (same link as the toast).
          App.navigate(NotificationCenter.getInstance().emailReplyFragment(this.model.get('content')).substring(1),
              {trigger: true});
          break;
        default:
          if (this.model.get('content').data && this.model.get('content').data.from) {
            App.navigate('customers/code/' + this.model.get('content').data.from, {trigger: true});
          }
      }

      if(this.field.onClose)
        this.field.onClose();
    }
  });
});
